import { createSlice } from '@reduxjs/toolkit'

const initialState = { user: null, role: null, token: null, activeRole: null }

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setAuth: (state, action) => {
      const { token } = action.payload
      state.token = token
    },
    setCredentials: (state, action) => {
      const { user, role } = action.payload
      state.user = user
      state.role = role
      state.activeRole = role
    },
    logOut: (state) => {
      state.user = null
      state.role = null
      state.token = null
      state.activeRole = null
    },
    switchRole: (state, action) => {
      if (
        state.role[0].rolename === 'Oraculo' &&
        process.env.REACT_APP_ENABLE_ROLE_SWAP === 'true'
      ) {
        state.activeRole = [action.payload]
      }
    },
  },
})

export const { setCredentials, logOut, setAuth, switchRole } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentUserRoles = (state) =>
  state.auth.role ? state.auth.role.map((role) => role.rolename) : null
export const selectCurrentActiveRoles = (state) =>
  state.auth.activeRole
    ? state.auth.activeRole.map((role) => role.rolename)
    : [null]
export const selectCurrentToken = (state) => state.auth.token
